export enum InboundType {
  CALL = 'call',
  MESSAGE = 'message',
  //   FAX = 'fax',
  //   VIDEO = 'video',
}

export enum InboundProvider {
  TWILIO = 'twilio',
}

